import type { LevelDefinition } from "@/domain";

import type { RhythmPhrasePayload } from "./types";

const instruction =
  "先听点点读一遍，再按顺序点出英文词，最后跟着节奏读出来。";
const promptAudio = "/audio/english/instructions/rhythm-phrases.ogg";

export const rhythmPhraseLevels: LevelDefinition<RhythmPhrasePayload>[] = [
  {
    id: "english-rhythm-phrases-1",
    domain: "english",
    activityType: "rhythm-phrases",
    difficulty: 1,
    objectives: ["听辨并跟读一个词的问候用语"],
    title: "课堂英语节奏 1",
    instruction,
    promptAudio,
    assets: ["/audio/english/phrases/hello.ogg"],
    payload: {
      kind: "rhythm-phrases",
      modelAudio: "/audio/english/phrases/hello.ogg",
      tokenAudio: {
        hello: "/audio/english/words/hello.ogg"
      },
      caption: "hello",
      beatCuesMs: [0],
      toleranceMs: 500,
      answerTokens: ["hello"]
    }
  },
  {
    id: "english-rhythm-phrases-2",
    domain: "english",
    activityType: "rhythm-phrases",
    difficulty: 2,
    objectives: ["按节奏跟读两个词的礼貌用语"],
    title: "课堂英语节奏 2",
    instruction,
    promptAudio,
    assets: ["/audio/english/phrases/thank-you.ogg"],
    payload: {
      kind: "rhythm-phrases",
      modelAudio: "/audio/english/phrases/thank-you.ogg",
      tokenAudio: {
        thank: "/audio/english/words/thank.ogg",
        you: "/audio/english/words/you.ogg"
      },
      caption: "thank you",
      beatCuesMs: [0, 650],
      toleranceMs: 475,
      answerTokens: ["thank", "you"]
    }
  },
  {
    id: "english-rhythm-phrases-3",
    domain: "english",
    activityType: "rhythm-phrases",
    difficulty: 3,
    objectives: ["听懂并跟读简短的课堂指令"],
    title: "课堂英语节奏 3",
    instruction,
    promptAudio,
    assets: ["/audio/english/phrases/sit-down.ogg"],
    payload: {
      kind: "rhythm-phrases",
      modelAudio: "/audio/english/phrases/sit-down.ogg",
      tokenAudio: {
        sit: "/audio/english/words/sit.ogg",
        down: "/audio/english/words/down.ogg"
      },
      caption: "sit down",
      beatCuesMs: [0, 600],
      toleranceMs: 450,
      answerTokens: ["sit", "down"]
    }
  },
  {
    id: "english-rhythm-phrases-4",
    domain: "english",
    activityType: "rhythm-phrases",
    difficulty: 4,
    objectives: ["听懂并跟读课堂动作指令"],
    title: "课堂英语节奏 4",
    instruction,
    promptAudio,
    assets: ["/audio/english/phrases/stand-up.ogg"],
    payload: {
      kind: "rhythm-phrases",
      modelAudio: "/audio/english/phrases/stand-up.ogg",
      tokenAudio: {
        stand: "/audio/english/words/stand.ogg",
        up: "/audio/english/words/up.ogg"
      },
      caption: "stand up",
      beatCuesMs: [0, 550],
      toleranceMs: 425,
      answerTokens: ["stand", "up"]
    }
  },
  {
    id: "english-rhythm-phrases-5",
    domain: "english",
    activityType: "rhythm-phrases",
    difficulty: 5,
    objectives: ["按顺序跟读三个词的课堂指令"],
    title: "课堂英语节奏 5",
    instruction,
    promptAudio,
    assets: ["/audio/english/phrases/open-your-book.ogg"],
    payload: {
      kind: "rhythm-phrases",
      modelAudio: "/audio/english/phrases/open-your-book.ogg",
      tokenAudio: {
        open: "/audio/english/words/open.ogg",
        your: "/audio/english/words/your.ogg",
        book: "/audio/english/words/book.ogg"
      },
      caption: "open your book",
      beatCuesMs: [0, 500, 1000],
      toleranceMs: 400,
      answerTokens: ["open", "your", "book"]
    }
  },
  {
    id: "english-rhythm-phrases-6",
    domain: "english",
    activityType: "rhythm-phrases",
    difficulty: 6,
    objectives: ["跟着更紧凑的节奏读出课堂指令"],
    title: "课堂英语节奏 6",
    instruction,
    promptAudio,
    assets: ["/audio/english/phrases/raise-your-hand.ogg"],
    payload: {
      kind: "rhythm-phrases",
      modelAudio: "/audio/english/phrases/raise-your-hand.ogg",
      tokenAudio: {
        raise: "/audio/english/words/raise.ogg",
        your: "/audio/english/words/your.ogg",
        hand: "/audio/english/words/hand.ogg"
      },
      caption: "raise your hand",
      beatCuesMs: [0, 450, 900],
      toleranceMs: 375,
      answerTokens: ["raise", "your", "hand"]
    }
  }
];
